<h1 class="text-white text-lg font-semibold mb-4">Gestión de Descuentos</h1>
<div class="mb-4 flex justify-between items-center">
    <button matButton (click)="onCreateDiscount()" *ngIf="canCreateDiscount$ | async">
        <mat-icon>add</mat-icon> Crear Nuevo Descuento
    </button>
    <mat-form-field class="ml-4">
        <input matInput (input)="applyFilter($event)" placeholder="Buscar...">
    </mat-form-field>
</div>
<div *ngIf="dataSource.data.length === 0" class="text-center py-8 text-gray-500">
    <p>No hay descuentos registrados.</p>
</div>
<div class="mat-elevation-z2">
    <table mat-table [dataSource]="dataSource" matSort class="w-full">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
            <td mat-cell *matCellDef="let discount"> {{ discount.name }} </td>
        </ng-container>
        <ng-container matColumnDef="defaultAmount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Monto (Q) </th>
            <td mat-cell *matCellDef="let discount"> Q {{ discount.defaultAmount | number:'1.2-2' }} </td>
        </ng-container>
        <ng-container matColumnDef="calculationStrategy">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Aplica Diariamente </th>
            <td mat-cell *matCellDef="let discount"> 
                <span *ngIf="discount.calculationStrategy === 'PER_UNIT_PER_DAY'">Sí</span>
                <span *ngIf="discount.calculationStrategy === 'PER_UNIT_FLAT_PERIOD'">No</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="assignmentType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Asignación por </th>
            <td mat-cell *matCellDef="let discount"> {{ getAssignmentTypeDisplayName(discount.assignmentType) }} </td>
        </ng-container>
<ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado </th>
            <td mat-cell *matCellDef="let discount"> {{ discount.status ? 'Activo' : 'Inactivo' }} </td>
        </ng-container>
        <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Creado </th>
            <td mat-cell *matCellDef="let discount">{{ discount.createdAt | date:'dd-MM-yyyy, hh:mm:ss a' }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Acciones </th>
            <td mat-cell *matCellDef="let discount">
                <button mat-icon-button color="accent" aria-label="Editar descuento" (click)="onEditDiscount(discount)" *ngIf="canEditDiscount$ | async">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" aria-label="Eliminar descuento" (click)="onDeleteDiscount(discount.id)" *ngIf="canDeleteDiscount$ | async">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Seleccionar página de descuentos"></mat-paginator>
</div>
